/*
 *   File : cancel-sip.js
 *   Author URI : https://evoqins.com
 *   Description : Confirmation UI to be shown before Cancelling an active SIP.
 *   Integrations : null
 *   Version : v1.1
 */

import { useEffect, useState } from "react";

import { GradientButton, OutlineButton } from "../CTA";
import { CustomSelectBox, CustomTextInput } from "../Form-elements";
import Icon from "../Icon/icon";
import { OTPInput } from "../Form-elements";
import { toast } from "react-toastify";

import { _consent2FA } from "../../Helper/api";
import APIService from "../../Service/api-service";

import style from "../../Styles/Component/cancel-sip.module.scss"

const CancelSIPModal = (props) => {

    const [reasons, setReasons] = useState([]);
    const [selectedReason, setSelectedReason] = useState(null);
    const [otherReason, setOtherReason] = useState("");
    const [selectReasonError, setSelectReasonError] = useState("");
    const [otherReasonError, setOtherReasonError] = useState("");
    const [verifyOTP, setVerifyOTP] = useState(false);
    const [seconds, setSeconds] = useState(30);
    const [pinString, setPinString] = useState("");
    const [errorMessage, setErrorMessage] = useState(false);
    const [buttonLoader, setButtonLoader] = useState(false);

    useEffect(() => {
        var my_modal = document.getElementById("cancel-sip");
        my_modal.addEventListener("hidden.bs.modal", () => {
            props.close();
        });
    }, []);

    useEffect(() => {
        if (verifyOTP === true) {
            const countdown = setInterval(() => {
                if (seconds > 0) {
                    setSeconds(seconds - 1);
                } else {
                    clearInterval(countdown);
                    // Handle expiration logic here (e.g., show a resend button)
                }
            }, 1000);

            return () => {
                clearInterval(countdown);
            };
        } else {
            setSeconds(30);
        }
    }, [seconds, verifyOTP]);

    useEffect(() => {
        _getReasons();
    }, []);

    function _handleReason(value) {
        setSelectedReason(value);
        setSelectReasonError("");
    }

    function _handleInput(value) {
        setOtherReason(value);
        setOtherReasonError("");
    }

    const _handlePin = (value) => {
        setPinString(value);
        setErrorMessage("");
    }

    function _getReasons() {
        let url = 'sip/reason-list';
        APIService(false, url).then((response) => {
            if (response.status_code === 200) {
                let updated_reason = response.data.map((item, key) => {
                    return ({ value: item.id, label: item.name })
                });
                setReasons(updated_reason);
            }
        })
    }

    const _requestOTP = () => {

        if (selectedReason === null) {
            setSelectReasonError("Reason is required");
            return;
        } else if (selectedReason.value == 13 && otherReason === '') {
            setOtherReasonError("Please specify reason");
            return;
        }
        _getOTP();
    }


    async function _handleSubmit() {
        if (pinString === "") {
            setErrorMessage("OTP is required");
            return;
        }
        try {
            setButtonLoader(true);
            let response = await props.cancel(pinString, selectedReason.value, otherReason);
            setButtonLoader(false);
            const close_button = document.getElementById("close-modal");
            close_button.click();
        } catch (error) {

        }

    }

    function _getOTP() {
        setButtonLoader(true);
        _consent2FA("SIP_CANCEL")
            .then((response) => {
                toast.dismiss();
                toast.success("OTP sent to your registered email and phone number", {
                    type: "success",
                });
                setSeconds(30);
                setPinString("");
                setVerifyOTP(true);
                setButtonLoader(false);
            }).catch((response) => {
                setButtonLoader(false);
                toast.dismiss();
                toast.error(response, {
                    type: "error"
                });
            });
    }
    return (
        <div className={`modal fade ${style.e_sip_modal}`}
            id="cancel-sip"
            tabIndex="-1"
            aria-labelledby="cancel-sip"
            aria-hidden="true"
            data-bs-backdrop="true" >
            <div className={`modal-dialog position-relative modal-dialog-centered ${style.e_dialog}`}>
                <div className={`modal-content  padding-32px-lr pb-3 ${style.e_content} `}>
                    <Icon icon="close"
                        size={24}
                        data-bs-dismiss="modal"
                        className={`position-absolute cursor-pointer e-modal-close-btn ${style.e_close}`} />

                    {
                        verifyOTP === false ?
                            <>
                                <div className="text-center">
                                    <img src={require("../../Assets/Images/manage-sip/cancel-sip-delete.png")}
                                        alt="Delete SIP"
                                        width={72}
                                        height={72} />
                                </div>
                                <p className="color-eerie-black e-poppins-medium e-font-18 mb-3 mt-4">Are you sure you want to cancel your SIP?</p>

                                <div className="position-relative border-radius-8px cancel-sip-warning p-2 ps-3">
                                    <div className={`bg-chinese-orange position-absolute top-0 left-0 h-100 ${style.e_warning}`}>

                                    </div>
                                    <div className="d-flex align-items-center mb-2">
                                        <img src={require("../../Assets/Images/manage-sip/danger-triangle.png")}
                                            alt="Danger"
                                            width={24}
                                            height={24} />
                                        <p className="color-kenyan-copper e-poppins-semi-bold e-font-12 mb-0 ms-1">Warning</p>
                                    </div>
                                    <p className="color-medium-carmine e-poppins-medium e-font-12 mb-0">Cancelling SIP will affect your portfolio.</p>
                                </div>

                                <div className="col-12 mt-4">
                                    <CustomSelectBox value={selectedReason}
                                        label="Reason "
                                        error={selectReasonError}
                                        postfix="*"
                                        className="margin-32px-bottom "
                                        options={reasons}
                                        onSelectChange={_handleReason} />
                                </div>

                                {
                                    selectedReason !== null && selectedReason.value == 13 &&
                                    <div className="col-12 ">
                                        <CustomTextInput label="Specify reason"
                                            postfix="*"
                                            type="text"
                                            value={otherReason}
                                            error={otherReasonError}
                                            handleChange={_handleInput} />
                                    </div>
                                }

                                <div className="mt-4 d-flex justify-content-center gap-8px">
                                    {/* <OutlineButton label="Cancel"
                            id="close-button"
                            cancel="modal"
                            className="e-font-16 e-poppins-regular px-4 padding-12px-tb" /> */}
                                    <GradientButton label="Cancel SIP"
                                        className="e-font-16 px-3 padding-12px-tb"
                                        loading={buttonLoader}
                                        handleClick={_requestOTP} />

                                </div>
                            </>
                            :
                            <>
                                <div className="col-12 text-center">
                                    <img src={require('../../Assets/Images/payment-pin.svg').default}
                                        alt="Pin icon"
                                        draggable={false}
                                        width={72}
                                        height={72} />
                                </div>
                                <p className="color-outer-space e-poppins-regular e-font-14 mb-4 margin-20px-top">
                                    Enter OTP you have received in registered email and phone number to resume SIP
                                </p>

                                <button className="d-none" data-bs-dismiss="modal" id="close-modal"></button>
                                <div className="d-flex flex-column align-items-center text-start">
                                    <OTPInput pinString={pinString}
                                        id="sip-otp"
                                        autoFocus={true}
                                        pinError={errorMessage}
                                        disabled={buttonLoader}
                                        handleChange={_handlePin} />
                                    <div className="d-flex justify-content-center mt-lg-4 mt-md-4 mt-0">
                                        {
                                            seconds === 0 ?
                                                <p className='color-primary-color e-poppins-regular e-font-14 line-height-14px cursor-pointer mb-0 e-forgot-pin position-relative w-max-content'
                                                    onClick={_getOTP}>Resend OTP</p>
                                                :
                                                <p className='color-primary-color e-poppins-regular e-font-14 line-height-14px cursor-not-allowed mb-0 '>
                                                    Resend OTP in <span className="color-black">{seconds}s</span>
                                                </p>
                                        }

                                    </div>

                                    <GradientButton label="Confirm"
                                        loading={buttonLoader}
                                        className="w-100 padding-14px-tb margin-32px-top"
                                        handleClick={_handleSubmit} />
                                </div>
                            </>
                    }




                </div>
            </div>
        </div>
    )
}

export default CancelSIPModal